// import { PageHeader } from "@ant-design/pro-layout";
import { PageHeader } from "../../../shared/page-header";
import { OnboardingSubPageLayout } from "../onboarding-sub-page-layout";
import { Helmet } from "react-helmet";
import { QualifyingQuestionsContainer } from "../components/qualifying-questions.container";

export const OnboardingQualifyingQuestions: React.FC = () => {
  return (
    <OnboardingSubPageLayout
      header={
        <PageHeader
          title="Credential Verification for Health Professionals"
          subTitle="Profile Creation"
          description="If you are unable to provide all information and documentation in one session, or if you leave the application for any reason, the information and documentation you provided will be saved for approximately 24 hours. After that time, it will no longer be available and you will be required to begin a new request."
        />
      }
    >
      <Helmet>
        <title>General Information</title>
      </Helmet>
      <QualifyingQuestionsContainer />
    </OnboardingSubPageLayout>
  );
};
